import { render } from "./InvoiceSentDetails.vue?vue&type=template&id=20ad28d0&ts=true"
import script from "./InvoiceSentDetails.vue?vue&type=script&lang=ts"
export * from "./InvoiceSentDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__